(() => {
  const root = document.documentElement;
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover:hover) and (pointer:fine)');
  const control = document.querySelector('.gtam-motion-control');
  let motionChoice = null, frame = 0;
  try {
    const stored = sessionStorage.getItem('gtam-motion-choice');
    if (stored === 'play') motionChoice = false;
    if (stored === 'pause') motionChoice = true;
  } catch {}
  function motionPaused() { return motionChoice ?? media.matches; }
  const initialized = new WeakSet();
  const scenes = new Set();
  const jackets = new Set();
  let observer;
  const selector = '.gtam-section-head,.gtam-service,.gtam-book-grid .don-book,.gtam-detail-grid article,.gtam-about>div,.gtam-process li,.gtam-story-intro>div,.gtam-music>div,.gtam-cta>h2';
  function initialize(scope = document) {
    if ('IntersectionObserver' in window && !observer) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('gtam-visible'); observer.unobserve(entry.target); }
      }), { threshold:.08 });
    }
    scope.querySelectorAll(selector).forEach(element => {
      if (initialized.has(element)) return;
      initialized.add(element);
      if (observer && !motionPaused()) {
        element.classList.add('gtam-reveal'); observer.observe(element);
      }
    });
    scope.querySelectorAll('.gtam-hero-art').forEach(scene => {
      if (scenes.has(scene)) return;
      scenes.add(scene);
      scene.addEventListener('pointermove',event => {
        if (motionPaused() || !fine.matches) return;
        const box = scene.getBoundingClientRect();
        scene.style.setProperty('--gtam-pointer-x',`${((event.clientX-box.left)/box.width-.5)*3}deg`);
        scene.style.setProperty('--gtam-pointer-y',`${((event.clientY-box.top)/box.height-.5)*-2}deg`);
      },{passive:true});
      scene.addEventListener('pointerleave',()=>{
        scene.style.setProperty('--gtam-pointer-x','0deg');scene.style.setProperty('--gtam-pointer-y','0deg');
      });
    });
    scope.querySelectorAll('.don-jacket').forEach(el=>jackets.add(el));
    requestPaint();
  }
  function paint() {
    frame = 0;
    const still = motionPaused();
    scenes.forEach(scene => {
      if (!scene.isConnected) { scenes.delete(scene); return; }
      const box = scene.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      const p = Math.max(0,Math.min(1,(innerHeight-box.top)/(innerHeight+box.height)));
      scene.style.setProperty('--gtam-scroll',still?0:p);
      scene.style.setProperty('--gtam-turn',`${still?0:p*36}deg`);
      scene.style.setProperty('--gtam-lift',`${still?0:(p-.5)*-14}px`);
    });
    jackets.forEach(jacket => {
      if (!jacket.isConnected) { jackets.delete(jacket); return; }
      const box = jacket.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      const p = Math.max(0,Math.min(1,(innerHeight-box.top)/(innerHeight+box.height)));
      jacket.style.setProperty('--gtam-cover-turn',`${still?0:(p-.5)*6}deg`);
      jacket.style.setProperty('--gtam-cover-lift',`${still?0:(p-.5)*-8}px`);
    });
  }
  function requestPaint() { if(!frame) frame=requestAnimationFrame(paint); }
  function sync() {
    const still = motionPaused();
    root.classList.toggle('gtam-motion-paused',still);
    root.classList.toggle('gtam-motion-user-enabled',motionChoice === false);
    if (control) {
      control.hidden=false;
      control.setAttribute('aria-pressed',String(still));
      const label=still?control.dataset.resumeLabel:control.dataset.pauseLabel;
      control.setAttribute('aria-label',label); control.title=label;
    }
    if(still)document.querySelectorAll('.gtam-reveal').forEach(el=>el.classList.add('gtam-visible'));
    scenes.forEach(el=>{el.style.setProperty('--gtam-pointer-x','0deg');el.style.setProperty('--gtam-pointer-y','0deg');});
    requestPaint();
  }
  control?.addEventListener('click',()=>{
    motionChoice = !motionPaused();
    try { sessionStorage.setItem('gtam-motion-choice',motionChoice?'pause':'play'); } catch {}
    sync();
  });
  media.addEventListener('change',sync);
  addEventListener('scroll',requestPaint,{passive:true});
  addEventListener('resize',requestPaint,{passive:true});
  document.addEventListener('visibilitychange',()=>root.classList.toggle('gtam-tab-hidden',document.hidden));
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  initialize();sync();
})();
